import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconShare48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="share">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 31C12.866 31 16 27.866 16 24C16 20.134 12.866 17 9 17C5.13401 17 2 20.134 2 24C2 27.866 5.13401 31 9 31ZM9 33C13.9706 33 18 28.9706 18 24C18 19.0294 13.9706 15 9 15C4.02944 15 0 19.0294 0 24C0 28.9706 4.02944 33 9 33Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35 16C38.866 16 42 12.866 42 9C42 5.13401 38.866 2 35 2C31.134 2 28 5.13401 28 9C28 12.866 31.134 16 35 16ZM35 18C39.9706 18 44 13.9706 44 9C44 4.02944 39.9706 0 35 0C30.0294 0 26 4.02944 26 9C26 13.9706 30.0294 18 35 18Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35 46C38.866 46 42 42.866 42 39C42 35.134 38.866 32 35 32C31.134 32 28 35.134 28 39C28 42.866 31.134 46 35 46ZM35 48C39.9706 48 44 43.9706 44 39C44 34.0294 39.9706 30 35 30C30.0294 30 26 34.0294 26 39C26 43.9706 30.0294 48 35 48Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.47 19.152L27.47 11.652L28.53 13.348L16.53 20.848L15.47 19.152Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9918 27.9953L28.4957 35.1315L27.5043 36.8685L15.0004 29.7323L15.9918 27.9953Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconShare24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="share">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 15C6.65685 15 8 13.6569 8 12C8 10.3431 6.65685 9 5 9C3.34315 9 2 10.3431 2 12C2 13.6569 3.34315 15 5 15ZM5 17C7.76142 17 10 14.7614 10 12C10 9.23858 7.76142 7 5 7C2.23858 7 0 9.23858 0 12C0 14.7614 2.23858 17 5 17Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8ZM18 10C20.7614 10 23 7.76142 23 5C23 2.23858 20.7614 0 18 0C15.2386 0 13 2.23858 13 5C13 7.76142 15.2386 10 18 10Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22ZM18 24C20.7614 24 23 21.7614 23 19C23 16.2386 20.7614 14 18 14C15.2386 14 13 16.2386 13 19C13 21.7614 15.2386 24 18 24Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.48548 9.14253L13.4855 6.14251L14.5145 7.8575L9.51447 10.8575L8.48548 9.14253Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.44723 13.1056L14.4473 16.1056L13.5528 17.8945L7.55281 14.8945L8.44723 13.1056Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconShare16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="share">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 3.5C14 4.32843 13.3284 5 12.5 5C11.6716 5 11 4.32843 11 3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5ZM12.5 7C14.433 7 16 5.433 16 3.5C16 1.567 14.433 0 12.5 0C10.567 0 9 1.567 9 3.5C9 3.57397 9.00229 3.6474 9.00682 3.72023L5.90782 4.95983C5.28043 4.36494 4.43283 4 3.5 4C1.567 4 0 5.567 0 7.5C0 9.433 1.567 11 3.5 11C4.42194 11 5.26062 10.6435 5.88574 10.0609L9.09953 11.6678C9.03448 11.9345 9 12.2132 9 12.5C9 14.433 10.567 16 12.5 16C14.433 16 16 14.433 16 12.5C16 10.567 14.433 9 12.5 9C11.578 9 10.7394 9.35647 10.1142 9.9391L6.90046 8.33221C6.96551 8.06548 7 7.78677 7 7.5C7 7.22925 6.96926 6.96568 6.91107 6.71259L9.69808 5.59779C10.3365 6.44916 11.3539 7 12.5 7ZM3.5 9C4.32843 9 5 8.32843 5 7.5C5 6.67157 4.32843 6 3.5 6C2.67157 6 2 6.67157 2 7.5C2 8.32843 2.67157 9 3.5 9ZM12.5 14C13.3284 14 14 13.3284 14 12.5C14 11.6716 13.3284 11 12.5 11C11.6716 11 11 11.6716 11 12.5C11 13.3284 11.6716 14 12.5 14Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
